/* BASE COMPONENT */
class WDNBase extends HTMLElement {
  constructor() {
    super();
    this.states = {
      disabled: "disabled",
      open: "open",
      closed: "closed",
      selected: "selected",
      active: "active",
      loading: "loading",
      blank: "null",
    };
  }

  /**
   *
   * @param {string} name
   * @param {node} target
   */
  set_state(name, target) {
    var target = target || this;
    target.setAttribute("data-state", name);
  }

  /**
   *
   * @param {string} name
   * @param {node} target
   */
  clear_state(target) {
    var target = target || this;
    target.removeAttribute("data-state");
  }

  /**
   *
   * @param {node} target
   * @returns
   */
  get_state(target) {
    var target = target || this;
    return target.getAttribute("data-state");
  }

  /**
   *
   * @param {node} node_list
   * @param {string} event
   * @param {function} callback
   */
  bind_element(node, event, callback) {
    if (!node || !event || !callback) return;
    node.addEventListener(event, callback);
  }

  /**
   *
   * @param {node} node_list
   * @param {string} event
   * @param {function} callback
   */
  unbind_element(node, event, callback) {
    if (!node || !event || !callback) return;
    node.removeEventListener(event, callback);
  }

  /**
   *
   * @param {nodeList} node_list
   * @param {string} event
   * @param {function} callback
   */
  bind_elements(node_list, event, callback) {
    node_list.forEach(function (node) {
      this.bind_element(node, event, callback);
    }, this);
  }

  /**
   *
   * @param {string} selector
   * @param {target} selector
   */
  find_element(selector, target) {
    if (!selector) return;
    var target = target || document;
    return target.querySelector(selector);
  }

  /**
   *
   * @param {string} selector
   * @param {target} selector
   */
  find_elements(selector, target) {
    if (!selector) return;
    var target = target || document;
    return target.querySelectorAll(selector);
  }

  /**
   *
   * @param {object} data
   */
  fire_event(data) {
    var target = data.target || document.body;
    target.dispatchEvent(new CustomEvent(data.name, { detail: data.detail }));
  }

  /**
   *
   * @param {string} selector
   * @returns innerText converted to JSON
   */
  get_json_data(selector) {
    if (!selector) return;
    var container = this.find_element(selector);
    if (!container) return;
    return JSON.parse(container.innerText);
  }
}

/* SELECT COMPONENT */
class WDNSelect extends WDNBase {
  constructor() {
    super();
    this.config = {
      id: this.getAttribute("data-id"),
    };

    this.data = {};

    this.init();
  }

  // new code
  cache_nodes() {
    this.option_list = Array.from(this.nodes.options).map(function (option) {
      return {
        element: option,
        value: option.getAttribute("data-option"),
        label: option.innerText,
      };
    });
  }

  // new code
  // fix -- ? pehaps we rename this one to store_active?
  find_active() {
    this.data.active_option = this.option_list.find(function (option) {
      return option.element.getAttribute("data-state") == "selected";
    });
  }

  // new code - perhaps rename to store_blank ?
  find_blank() {
    this.data.blank_option = this.option_list.find(function (option) {
      return option.element.getAttribute("data-option") == "null";
    });
  }

  // new code
  store_active() {
    // fix -- ? is this really needed?
    return;
    this.data.active_element = this.data.active_option ? this.data.active_option.element : false;
    this.data.active_value = this.data.active_option ? this.data.active_option.value : false;
  }

  // new code
  read_defaults() {
    this.cache_nodes();
    this.find_active();
    this.find_blank();
    this.store_active();
  }

  // new code
  assign_nodes() {
    this.nodes = {
      native_select: this.find_element("[data-native-select]", this),
      options: this.find_elements("[data-option]", this),
    };
  }

  // Returns Option node
  get_active_option() {
    return this.data.acive_option;
  }

  //- done
  // Selects option with "null" value
  select_blank() {
    if (!this.data.blank_option) return;
    this.clear_active_option();
    this.data.active_option = this.data.blank_option;
    this.set_active_attribute();
  }

  // combine with handle_option_change function ?
  select_option_by_value(value) {
    this.option_list.forEach(function (option) {
      if (option.value == value) {
        this.clear_active_option();
        this.data.active_option = option;
      }
    }, this);
  }

  // option click handler
  // new code
  handle_option_change(e) {
    this.clicked_option = e.currentTarget;
    this.clicked_option_value = this.clicked_option.getAttribute("data-option");

    if (this.clicked_option.getAttribute("data-state") === "disabled") return;
    this.on_option_click();

    if (this.data.active_option.value == this.clicked_option_value) return;

    this.clear_active_option();
    this.data.active_option = {
      element: this.clicked_option,
      value: this.clicked_option_value,
      label: this.clicked_option.innerText,
    };

    this.on_option_change();
  }

  // new code
  clear_active_option() {
    if (!this.data.active_option) return;
    this.data.active_option.element.removeAttribute("data-state");
    this.data.active_option.element.classList.remove("is-selected");
    this.data.active_option = false;
  }

  // new code
  set_active_attribute() {
    this.data.active_option.element.setAttribute("data-state", "selected");
    this.data.active_option.element.classList.add("is-selected");
  }

  // new code
  update_native_select() {
    Array.from(this.nodes.native_select.options).forEach(function (option) {
      if (option.value === this.data.active_option.value) {
        option.selected = true;
      }
    }, this);
  }

  // new code
  on_option_change() {
    // add attribute to active option element
    this.set_active_attribute();
    this.store_active();
    this.update_native_select();
    this.fire_change_event();
  }

  // new code
  on_option_click() {
    this.fire_click_event();
  }

  fire_click_event() {
    this.dispatchEvent(new CustomEvent("option:clicked", { detail: this }));
  }

  // new code
  fire_change_event() {
    this.dispatchEvent(new Event("change", { detail: this }));
    this.nodes.native_select.dispatchEvent(new Event("change", { detail: this }));
  }

  // adding event listeners
  listen_for_events() {
    this.option_list.forEach(function (option) {
      this.bind_element(option.element, "click", this.handle_option_change.bind(this));
    }, this);
  }

  // module starts here
  init() {
    this.assign_nodes();
    this.read_defaults();
    this.listen_for_events();
    this.dispatchEvent(new CustomEvent("select:inited", {}));
  }
}

/* POPUP COMPONENT */
class WDNPopup extends WDNBase {
  constructor() {
    super();

    this.config = {
      id: this.getAttribute("data-id"),
      position: "",
      preferredPosition: this.getAttribute("data-preferred-position"),
      alignment: "",
      dispatch_events: "",
      mobile_breakpoint: 350,
      threshold: 20,
      classes: [
        "Popover--positionBottom",
        "Popover--positionTop",
        "Popover--positionCenter",
        "Popover--alignTop",
        "Popover--alignCenter",
        "Popover--alignBottom",
      ],
    };

    this.selectors = {
      page_overlay: ".PageOverlay",
      trigger: "[data-popup-trigger='" + this.config.id + "']",
      closer: "[data-popup-closer='" + this.config.id + "']",
    };

    this.nodes = {
      page_overlay: this.find_element(this.selectors.page_overlay),
      trigger: this.find_element(this.selectors.trigger),
      closers: this.find_elements(this.selectors.closer),
    };

    this.data = {};

    this.init();
  }

  calculate_element_position() {
    var windowHeight = window.innerHeight,
      triggerBoundingRect = this.nodes.trigger.getBoundingClientRect(),
      halfHeight = windowHeight / 2;

    var topPosition = 0,
      rightPosition = 0,
      position = this.config.position,
      alignment = this.config.alignment,
      threshold = this.config.threshold;

    if (this.config.preferredPosition === "bottom") {
      alignment = "right";

      if (
        this.clientHeight <= windowHeight - (triggerBoundingRect.bottom + threshold) ||
        windowHeight - triggerBoundingRect.bottom >= halfHeight
      ) {
        position = "bottom";
      } else {
        position = "top";
      }
    } else if (this.config.preferredPosition === "top") {
      alignment = "right";

      if (this.clientHeight <= triggerBoundingRect.top - threshold || triggerBoundingRect.top >= halfHeight) {
        position = "top";
      } else {
        position = "bottom";
      }
    } else if (this.config.preferredPosition === "right") {
      // aug22
      position = "right";
    } else {
      position = "left";
    }
    var halfElementHeight = this.clientHeight / 2;

    if (
      triggerBoundingRect.top >= halfElementHeight &&
      windowHeight - triggerBoundingRect.bottom >= halfElementHeight
    ) {
      alignment = "center";
    } else if (windowHeight - triggerBoundingRect.bottom >= halfElementHeight) {
      alignment = "bottom";
    } else {
      alignment = "top";
    }

    if (position === "top") {
      topPosition = triggerBoundingRect.top - this.clientHeight - threshold;
      rightPosition = window.innerWidth - triggerBoundingRect.right;
    } else if (position === "bottom") {
      topPosition = triggerBoundingRect.bottom + threshold;
      rightPosition = window.innerWidth - triggerBoundingRect.right;
    } else {
      rightPosition = window.innerWidth - triggerBoundingRect.left + threshold;

      // aug22
      if (position == "right") {
        rightPosition = window.innerWidth - triggerBoundingRect.right - this.offsetWidth - threshold;
      }

      if (alignment === "center") {
        topPosition = triggerBoundingRect.top - this.clientHeight / 2 + this.nodes.trigger.clientHeight / 2;
      } else if (alignment === "top") {
        topPosition = triggerBoundingRect.bottom - this.clientHeight;
      } else {
        topPosition = triggerBoundingRect.top;
      }
    }

    this.data.alignment = alignment;
    this.data.position = position;
    return {
      top: topPosition,
      right: rightPosition,
    };
  }

  adjust_element_indicator(position) {
    var element_class = this.classList;
    var element_position = this.data.position;
    var element_alignment = this.data.alignment;
    this.config.classes.map(function (item) {
      return element_class.remove(item);
    });

    element_class.add("Popover--position" + (element_position.charAt(0).toUpperCase() + element_position.slice(1)));
    element_class.add("Popover--align" + (element_alignment.charAt(0).toUpperCase() + element_alignment.slice(1)));

    this.setAttribute("style", "top: " + parseInt(position.top) + "px; right: " + parseInt(position.right) + "px;");
  }

  position_element() {
    var position = this.calculate_element_position();
    this.adjust_element_indicator(position);
    this.style.top = window.innerWidth >= 1008 ? position.top + "px" : "auto";
    this.style.right = position.right + "px";
  }

  open() {
    if (window.innerWidth <= 1007) {
      this.nodes.page_overlay.classList.add("is-visible");
    }
    this.setAttribute("aria-hidden", "false");
    document.body.classList.add("popup--open");
    document.body.classList.add("no-scroll");
    this.bind_body(true);
  }

  close() {
    if (window.innerWidth <= 1007) {
      this.nodes.page_overlay.classList.remove("is-visible");
    }
    this.setAttribute("aria-hidden", "true");
    document.body.classList.remove("popup--open");
    document.body.classList.remove("no-scroll");
    this.bind_body(false);
  }

  // event handlers
  body_on_click(e) {
    if (this.contains(e.target) || this.nodes.trigger.contains(e.target)) return;
    this.close();

    return;
    if (e.target.classList.contains("popup--open")) {
      this.close();
    }
  }

  window_on_resize() {
    this.position_element();
  }

  trigger_on_click(e) {
    this.position_element();
    this.open();
  }

  closer_on_click() {
    this.close();
  }

  body_on_close_event() {
    this.close();
  }

  // bindings
  bind_body(state) {
    // pls fix, find better solution ?
    // consider reversing logic
    if (state) {
      this.bind_element(document.body, "click", this.body_on_click_bound);
    } else {
      this.unbind_element(document.body, "click", this.body_on_click_bound);
    }
    /*
    setTimeout(
      function () {
        if (state) {
          this.bind_element(document.body, "click", this.body_on_click_bound);
        } else {
          this.unbind_element(document.body, "click", this.body_on_click_bound);
        }
      }.bind(this),
      200
    );*/
  }

  bind() {
    this.body_on_click_bound = this.body_on_click.bind(this);
    this.bind_element(this.nodes.trigger, "click", this.trigger_on_click.bind(this));
    this.bind_elements(this.nodes.closers, "click", this.closer_on_click.bind(this));
    this.bind_element(document.body, "popup:close:all", this.body_on_close_event.bind(this));
    this.bind_element(window, "resize", this.window_on_resize.bind(this));
  }

  // Start function
  init() {
    this.position_element();
    this.bind();
  }
}

/* Definers */

/* VARIANT SELECT COMPONENT  */
class WDNVariantSelect extends WDNBase {
  constructor() {
    super();

    this.config = {
      id: this.getAttribute("data-variant-select"),
      is_on_product_page: !!this.find_element("[data-section-id='product-template']"),
    };

    this.nodes = {
      form: false,
      selects: this.find_elements("[data-select]", this),
      value_containers: this.find_elements("[data-selected-option='" + this.config.id + "']"),
    };

    this.data = {
      product_dump: this.get_json_data("[data-product-data][data-handle='" + this.config.id + "']")[0],
      stock_dump: this.get_json_data("[data-stock-dump]", this),
      selected_variant: false,
    };

    if (this.config.is_on_product_page) {
      this.init();
    } else {
      // last select child to load
      this.bind_element(this.nodes.selects[this.nodes.selects.length - 1], "select:inited", this.init.bind(this));
    }

    //   this.init();
  }

  // Returns variant's stock quantity
  get_variant_stock(variant_title) {
    var stock = this.data.stock_dump;
    if (!variant_title || !stock) return;
    var found_data = false;
    if (stock.hasOwnProperty(variant_title)) {
      found_data = stock[variant_title];
    }
    return found_data;
  }

  // done
  get_selected_variant_title() {
    var selected_options = [];
    this.nodes.selects.forEach(function (select) {
      selected_options.push(select.data.active_option.value);
    }, this);

    return selected_options.join(" / ");
  }

  register_changes_on_select() {
    var selected_option = this.data.selected_variant.data;
    var variant_title = selected_option.title.split(" / ");
    this.nodes.selects.forEach(function (select, i) {
      select.select_option_by_value(variant_title[i]);
    });
  }

  set_active_option_by_value(value) {
    var requested_variant = this.get_variant_by_title(value);
    if (!requested_variant) return;

    this.data.selected_variant = {
      data: requested_variant,
      stock: this.get_selected_variant_stock(),
    };

    this.register_changes_on_select();

    this.output_selected_variant();
  }

  // rewrite
  get_selected_variant() {
    return this.get_variant_by_title(this.get_selected_variant_title());
  }

  // rewrite
  get_selected_variant_stock() {
    return this.get_variant_stock(this.get_selected_variant_title());
  }

  assign_selected_variant() {
    var selected_variant = this.get_selected_variant();
    if (!selected_variant) return;
    this.data.selected_variant = {
      data: selected_variant,
      stock: this.get_selected_variant_stock(),
    };
  }

  output_selected_variant() {
    var output = this.data.selected_variant ? this.data.selected_variant.data.title : "";
    this.nodes.value_containers.forEach(function (container) {
      container.innerHTML = output;
    });
  }

  // Returns JSON of requested variant, if exists
  get_variant_by_title(variant_title) {
    var variants = this.data.product_dump.variants;
    var found_variant = false;
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (variant.title == variant_title) {
        found_variant = variant;
        break;
      }
    }

    return found_variant;
  }

  set_initial_state() {
    this.assign_selected_variant();
    this.output_selected_variant();
  }

  fire_change_event() {
    this.dispatchEvent(new Event("change", { detail: {} }));
  }

  collapse_popups() {
    this.fire_event({
      name: "popup:close:all",
      detail: {},
    });
  }

  // new
  handle_option_change(e) {
    this.assign_selected_variant();
    this.output_selected_variant();
    this.fire_change_event();
  }

  handle_option_click() {
    this.collapse_popups();
  }

  // new
  listen_for_events() {
    this.nodes.selects.forEach(function (select) {
      select.addEventListener("change", this.handle_option_change.bind(this));
      select.addEventListener("click", this.handle_option_click.bind(this));
    }, this);
  }

  init() {
    this.set_initial_state();
    this.listen_for_events();
    this.is_inited = true;
    this.dispatchEvent(new CustomEvent("variant_select:inited", {}));
  }
}

/* ADDON SELECT COMPONENT */
class WDNAddonSelect extends WDNBase {
  constructor() {
    super();
    this.config = {
      id: this.getAttribute("data-id"),
      button_class: "Popover__Value  Heading Link Link--primary u-h6",
      is_on_product_page: !!this.find_element("[data-section-id='product-template']"),
    };

    this.selectors = {
      variant_select: "[data-variant-select='" + this.config.id + "']",
      image_container: "[data-product-image]",
    };

    this.dependencies = {
      money: money,
    };

    this.nodes = {
      form: false,
      variant_select: this.find_element(this.selectors.variant_select),
      image_container: this.find_element(this.selectors.image_container),
      options: [],
    };
  }

  get_object_data(object, key) {
    if (object.hasOwnProperty(key)) {
      return object[key];
    }
  }

  listen_for_option_change() {
    this.bind_element(this.nodes.variant_select, "change", this.handle_option_change.bind(this));
  }

  fire_change_event(detail) {
    this.dispatchEvent(new CustomEvent("change", { detail: detail }));
  }

  find_active_option() {
    return this.find_element("button[data-state='selected']", this);
  }

  find_option_by_value(value) {
    return this.find_element("button[value='" + value + "']", this);
  }

  assign_blank_option() {
    this.data.blank_option = this.find_element("button[value='null']", this);
  }

  collapse_popups() {
    this.fire_event({
      name: "popup:close:all",
      detail: {},
    });
  }

  clear_active_option() {
    if (!this.data.selected_option) return;
    var element = this.data.selected_option.element;
    element.classList.remove("is-selected");
    element.setAttribute("data-state", "selected");
    this.data.selected_option = false;
  }

  assign_selected_option(element) {
    if (!element) return;
    this.clear_active_option();
    this.data.selected_option = {
      element: element,
      value: element.value,
      label: element.getAttribute("data-label"),
      type: element.innerHTML.split(" - ")[0],
    };

    element.classList.add("is-selected");
    element.setAttribute("data-state", "selected");
    this.output_active_value();
    if (typeof this.on_option_select === "function") {
      this.on_option_select();
    }
  }

  converted_passepartout_name = function (name) {
    //return name.split(" (")[0].replace("Passepartout - ", "");
    return name.replace("Passepartout - ", "");
  };

  output_active_value() {
    var output = this.converted_passepartout_name(this.data.selected_option ? this.data.selected_option.label : "");
    this.nodes.value_containers.forEach(function (container) {
      container.innerHTML = output;
    });
  }

  get_option_by_value(value) {
    return this.find_element("button[value='" + value + "']", this);
  }

  select_option_by_value(value) {
    var option = this.get_option_by_value(value);
    this.assign_selected_option(option);
    if (typeof this.on_option_select === "function") {
      this.on_option_select();
    }
  }

  select_blank() {
    this.assign_selected_option(this.data.blank_option);
    this.output_active_value();
    if (typeof this.on_select_clear === "function") {
      this.on_select_clear();
    }
  }

  /*
    nodes
      - poster 

    functions
      - logic for getting images based on variant  

  */
}

/* FRAME SELECT COMPONENT */
class WDNFrameSelect extends WDNAddonSelect {
  constructor() {
    super();

    // implement the storage

    this.data = {
      frame_dump: this.get_json_data("[data-frames-json='" + this.config.id + "']"),
    };

    this.init();
  }

  get_frames_by_size(size) {
    var frames = this.data.frame_dump.frames;
    var return_data = [];
    if (!frames || !size) return;
    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i];
      for (var j = 0; j < frame.variants.length; j++) {
        if (frame.variants[j].title == size) {
          return_data.push(frame.variants[j]);
        }
      }
    }

    return return_data;
  }

  get_frame_by_id(requested_id) {
    var frames = this.data.frame_dump.frames;
    var found_frame = false;
    if (!frames || !requested_id) return;

    frames.find(function (frame) {
      frame.variants.find(function (variant) {
        if (variant.id == requested_id) {
          found_frame = variant;
        }
      });
    });

    return found_frame;
  }

  // del
  get_related_frame_by_id(id) {
    return this.data.related_frames.find(function (frame) {
      return frame.id == id;
    });
  }

  get_frame_by_type_and_size(type, size) {
    var frames_by_type = this.data.frame_dump.frames.find(function (frame) {
      return frame.title === type;
    });

    if (!frames_by_type) return;

    var frame_by_size = frames_by_type.variants.find(function (frame) {
      return frame.title === size;
    });

    return frame_by_size;
  }

  generate_frame_options() {
    var output = [];
    var button_class = this.config.button_class;
    this.data.related_frames.forEach(function (frame) {
      var cost = " + " + this.dependencies.money(frame.price);
      var element =
        "<div class='option-wrapper'><button type='button' class='" +
        button_class +
        "' value='" +
        frame.name.split(" - ")[0] +
        "' data-label='" +
        frame.name +
        cost +
        "'>" +
        frame.name +
        cost +
        "</button></div>";
      output.push(element);
    }, this);

    this.data.options_output = output;
  }

  output_frame_options() {
    this.nodes.options_container.innerHTML = "";
    this.nodes.options_container.insertAdjacentHTML("beforeend", this.data.options_output.join(""));
  }

  // handles option click event
  handle_option_change() {
    var variant_select = this.nodes.variant_select.data;
    var passepartout_select = this.nodes.passepartout_select;

    if (!variant_select.selected_variant) return;

    this.data.poster_size = variant_select.selected_variant.data.title;

    // if passepartout exists and is selected
    if (passepartout_select && passepartout_select.data.selected_option.value !== "null") {
      // finding passepartout size based on the print size
      var passepartout_size = passepartout_select.find_passepartout_size_from_print_size(this.data.poster_size);

      if (passepartout_size) {
        // if passepartout size exists, set it as poster size
        this.data.poster_size = passepartout_size;
        passepartout_select.data.poster_size = passepartout_size;
      } else {
        // deselect passepartout
        passepartout_select.select_blank();
      }
    }

    // returns all frames that match the variant select size
    this.data.related_frames = this.get_frames_by_size(this.data.poster_size);

    // generates list of frame options
    this.generate_frame_options();

    // ouptuts generated list of frame options
    this.output_frame_options();

    // validates if frame with the same dimensions and color exists
    if (this.get_frame_by_type_and_size(this.data.selected_option.type, this.data.poster_size)) {
      this.select_option_by_value(this.data.selected_option.type);
    } else {
      this.select_blank();
    }

    // listens for events on the outputted options
    this.bind_new_nodes();
  }

  get_frame_product() {
    var selected_value = this.data.selected_option.value;
    if (selected_value === "null") return;
    return this.data.frame_dump.frames.find(function (frame) {
      return frame.title == selected_value;
    });
  }

  get_frame_variant() {
    var frame_product = this.get_frame_product();
    if (!frame_product) return;
    return frame_product.variants.find(function (variant) {
      return variant.title === this.data.poster_size;
    }, this);
  }

  update_frame_image() {
    var frame_product = this.get_frame_product();

    if (frame_product) {
      this.nodes.frame_image.classList.add("frame-module__image--visible");
      this.nodes.frame_image.style = "background-image:url(" + frame_product.image + ");";
      this.data.selected_product = frame_product;
    } else {
      this.nodes.frame_image.classList.remove("frame-module__image--visible");
      this.nodes.frame_image.style = "background-image:unset;";
      this.data.selected_product = false;
    }
  }

  // callback after logic is complete - used to append attributes, classes etc.
  on_option_select() {
    this.update_frame_image();
  }

  // callback after logic is complete - used to remove attributes, classes etc.
  on_select_clear() {
    this.update_frame_image();
  }

  bind_new_nodes() {
    this.nodes.options = this.find_elements("button", this.nodes.options_container);
    this.bind_elements(this.nodes.options, "click", this.handle_option_click.bind(this));
  }

  // click callback to frame options
  handle_option_click(e) {
    //  this.assign_selected_option(e.currentTarget);
    this.fire_change_event(e.currentTarget);
    this.collapse_popups();
  }

  assign_nodes() {
    this.nodes.options_container = this.find_element("[data-frame-options]", this);
    this.nodes.value_containers = this.find_elements("[data-selected-frame='" + this.config.id + "']");
    this.nodes.passepartout_select = this.find_element("wdn-passepartout-select[data-id='" + this.config.id + "']");
    this.nodes.frame_image = this.find_element("[data-frame-image='" + this.config.id + "']");
  }

  set_initial_state() {
    this.assign_blank_option();
    this.assign_selected_option(this.find_active_option());
    this.output_active_value();
  }

  preload_images() {
    if (!this.config.is_on_product_page) return;
    var dump = this.data.frame_dump.frames;
    var image_list = [];

    dump.forEach(function (product) {
      var newImage = new Image();
      newImage.src = product.image;
      image_list.push(newImage);
    });
  }

  bind() {
    this.bind_element(this.data.blank_option, "click", this.handle_option_click.bind(this));
  }

  init() {
    this.preload_images();
    this.assign_nodes();
    this.set_initial_state();
    this.bind();

    this.listen_for_option_change();
    this.is_inited = true;
    this.dispatchEvent(new CustomEvent("frame_select:inited", {}));
  }
}

/* PASSEPARTOUT SELECT COMPONENT */
class WDNPassepartoutSelect extends WDNAddonSelect {
  constructor() {
    super();

    this.data = {
      mappings: this.get_json_data("[data-passepartout-mappings='" + this.config.id + "']"),
      array: this.get_json_data("[data-passepartout-json='" + this.config.id + "']").passepartout,
      json_dump: this.get_json_data("[data-passepartout-json='" + this.config.id + "']"),
    };

    this.listen_for_option_change();

    this.search_by_print_size = new this.search_mappings("print");
    this.search_by_passepartout_size = new this.search_mappings("passepartout");

    this.init();
  }

  search_mappings = function (from) {
    var allowedFroms = ["passepartout", "print"];

    if (allowedFroms.indexOf(from) === -1) {
      return;
    }

    var search = function (query) {
      var results = this.data.mappings.filter(function (item) {
        if (item[from] === query) {
          return true;
        }
      });

      return results;
    };

    return search;
  };

  get_selected_passepartout_variant() {
    if (!this.data.selected_option || !this.data.selected_option) return;
    return this.data.related_passepartouts.find(
      function (variant) {
        return variant.name == this.data.selected_option.label.split(" +")[0];
      }.bind(this)
    );
  }

  get_passepartout_product_by_color(color) {
    return this.data.json_dump.passepartout.find(function (product) {
      if (product.title.indexOf(color) > -1) {
        return product;
      }
    });
  }

  // refactor
  update_passepartout_image() {
    var selected_value = this.data.selected_option.value;

    if (selected_value === "null") {
      this.nodes.passepartout_image.style = "background-image: unset;";
      this.nodes.gallery_wrapper.removeAttribute("data-gallery-has-passepartout");
      this.data.selected_product = false;
      return;
    }

    var selected_product = this.get_passepartout_product_by_color(selected_value);
    this.data.selected_product = selected_product;

    if (selected_product) {
      this.nodes.gallery_wrapper.setAttribute("data-gallery-has-passepartout", "");
      this.nodes.passepartout_image.style = "background-image: url(" + selected_product.image + ");";
    } else {
      this.nodes.gallery_wrapper.removeAttribute("data-gallery-has-passepartout");
      this.nodes.passepartout_image.style = "background-image: unset;";
    }
  }

  // callback after logic is complete - used to append attributes, classes etc.
  on_option_select() {
    this.update_passepartout_image();
  }

  // callback after logic is complete - used to remove attributes, classes etc.
  on_select_clear() {
    this.update_passepartout_image();
  }

  //  Determine passepartout size from print size
  find_passepartout_size_from_print_size(print_size) {
    var results = this.search_by_print_size(print_size);
    if (results.length === 0) {
      return false;
    }

    return results[0].passepartout;
  }

  // Determine print "format" based on print-size
  find_printout_size_from_passepartout(passepartout_size) {
    var results = this.search_by_passepartout_size(passepartout_size);

    if (results.size === 0) {
      return false;
    }

    return results[0].print;
  }

  // Determine validity of adding passepartout from print-size
  print_has_passepartout(print_size) {
    var result = this.find_passepartout_size_from_print_size(print_size);
    return !!result;
  }

  // Determine frame-size from passepartout size
  get_frame_size_by_passepartout_size(passepartout_size) {
    return this.find_printout_size_from_passepartout(passepartout_size);
  }

  // Get list of all passepartouts available in specific converted size
  find_all_matching_passepartout_variants(poster_variant) {
    var printVariant = poster_variant;
    var printSize = printVariant.option1;

    var passepartoutSize = this.find_passepartout_size_from_print_size(printSize);

    var matchedPassepartoutProductList = this.data.json_dump.passepartout
      .map(function (product) {
        var match = product.variants.find(function (variant) {
          // convert example: 40 x 50 cm (Window: 30x40) => 40 x 50 cm
          var convertedPassepartoutName = variant.option1.split(" (")[0];

          if (convertedPassepartoutName == passepartoutSize) {
            return true;
          }
        });

        return match;
      })
      .filter(function (match_item) {
        if (match_item) {
          return true;
        }
      });

    return matchedPassepartoutProductList;
  }

  find_passepartout_product_by_id(product_id) {
    return this.data.array.find(function (product) {
      if (product.id == product_id) {
        return product;
      }
    });
  }

  get_related_passepartout_by_variant_id(variant_id) {
    if (!this.data.related_passepartouts) return;
    return this.data.related_passepartouts.find(function (passepartout) {
      return passepartout.id == variant_id;
    });
  }

  get_passepartout_product_from = function (print_size, passepartout_color) {
    if (!this.print_has_passepartout(print_size)) {
      return;
    }

    var passepartout_size = this.find_passepartout_size_from_print_size(print_size);

    return this.data.json_dump.passepartout.find(function (item) {
      /* index of color in title -> then do the loop*/
      if (item.title.indexOf(passepartout_color) > -1) {
        var match = item.variants.find(function (variant) {
          // convert example: 40 x 50 cm (Window: 30x40) => 40 x 50 cm
          var converted_passepartout_name = variant.option1.split(" (")[0];

          if (converted_passepartout_name == passepartout_size) {
            return true;
          }
        });
        return match;
      }
    });
  };

  // handles variant change
  handle_option_change() {
    this.generate_passepartout_options();
    this.output_passepartout_options();
    this.bind_new_nodes();
  }

  generate_passepartout_options() {
    var selected_variant = this.nodes.variant_select.data.selected_variant;
    if (!selected_variant) return;

    this.data.related_passepartouts = this.find_all_matching_passepartout_variants(selected_variant.data);

    var output = [];
    var button_class = this.config.button_class;
    this.data.related_passepartouts.forEach(function (frame) {
      var cost = " + " + this.dependencies.money(frame.price);
      var element =
        "<div class='option-wrapper'><button type='button' class='" +
        button_class +
        "' value='" +
        frame.name.split(" - ")[1] +
        "' data-label='" +
        frame.name +
        cost +
        "'>" +
        frame.name.split("Passepartout - ")[1] +
        cost +
        "</button></div>";
      output.push(element);
    }, this);

    this.data.options_output = output;
  }

  output_passepartout_options() {
    if (!this.data.related_passepartouts) return;
    this.nodes.options_container.innerHTML = "";
    this.nodes.options_container.insertAdjacentHTML("beforeend", this.data.options_output.join(""));
  }

  assign_nodes() {
    this.nodes.options_container = this.find_element("[data-passepartout-options]", this);
    this.nodes.value_containers = this.find_elements("[data-selected-passepartout='" + this.config.id + "']");
    this.nodes.passepartout_image = this.find_element("[data-passepartout-image='" + this.config.id + "']");
    this.nodes.gallery_wrapper = this.find_element("[data-gallery-wrapper='" + this.config.id + "']");
  }

  // fires when passepartout option is clicked
  handle_option_click(e) {
    // this.assign_selected_option(e.currentTarget);
    this.fire_change_event(e.currentTarget);
    this.collapse_popups();
  }

  bind_new_nodes() {
    this.nodes.options = this.find_elements("button", this.nodes.options_container);
    this.bind_elements(this.nodes.options, "click", this.handle_option_click.bind(this));
  }

  set_initial_state() {
    this.assign_blank_option();
    this.assign_selected_option(this.find_active_option());
    this.output_active_value();

    this.generate_passepartout_options();
    this.output_passepartout_options();
    this.bind_new_nodes();
  }

  preload_images() {
    if (!this.config.is_on_product_page) return;
    var image_list = [];
    var dump = this.data.json_dump.passepartout;

    dump.forEach(function (product) {
      var newImg = new Image();
      newImg.src = product.image;
      image_list.push(newImg);
    });
  }

  bind() {
    this.bind_element(this.data.blank_option, "click", this.handle_option_click.bind(this));
  }

  init() {
    this.preload_images();
    this.assign_nodes();
    this.set_initial_state();
    this.bind();
    this.is_inited = true;
    this.dispatchEvent(new CustomEvent("passepartout_select:inited", {}));
  }
}

var money = function (amount) {
  return WDN.Money.Format(amount);
};

/* PRODUCT FORM COMPONENT */
class WDNProductForm extends WDNBase {
  constructor() {
    super();

    this.config = {
      id: this.getAttribute("data-id"),
      url_variant_param: "?variant=",
      is_on_product_page: !!this.find_element("[data-section-id='product-template']"),
      loaded_children: 0,
      has_url_params: this.getAttribute("data-no-params") !== "",
    };

    this.dependencies = {
      money: money,
    };

    this.nodes = {
      form: this.find_element("form", this),
      variant_select: this.find_element("[data-variant-select]", this),
      frame_select: this.find_element("wdn-frame-select", this),
      passepartout_select: this.find_element("wdn-passepartout-select", this),
      quantity_input: this.find_element("[data-quantity-for='" + this.config.id + "']"),
      price_containers: this.find_elements("[data-variant-price='" + this.config.id + "']"),
      compare_price_containers: this.find_elements("[data-variant-compareprice='" + this.config.id + "']"),
      total_price_containers: this.find_elements("[data-total-price='" + this.config.id + "']"),
      submit_button: this.find_element("[data-form-submit]", this),
    };

    if (this.config.is_on_product_page) {
      this.init();
    } else {
      // since custom elements are loaded different on wishlist
      this.wait_for_children_to_load();
    }
  }

  output_price(selected_variant) {
    var output_content = this.dependencies.money(selected_variant.price);
    this.nodes.price_containers.forEach(function (container) {
      container.innerHTML = output_content;
    });
  }

  get_quantity() {
    return parseInt(this.nodes.quantity_input.value);
  }

  output_compare_price(selected_variant) {
    var output_content = "";
    var compare_price = selected_variant.compare_at_price;
    var price = selected_variant.price;

    if (compare_price && compare_price > price) {
      output_content = this.dependencies.money(compare_price);
    }
    this.nodes.compare_price_containers.forEach(function (container) {
      container.innerHTML = output_content;
    });
  }

  output_total_price() {
    var price = this.dependencies.money(this.get_total_price());
    this.nodes.total_price_containers.forEach(function (container) {
      container.innerHTML = price;
    });
  }

  get_selected_variant() {
    if (!this.nodes.variant_select) return;
    return this.nodes.variant_select.data.selected_variant.data;
  }

  output_prices() {
    var form_data = this.get_form_data();
    if (!form_data.selected_variant) return;
    this.output_price(form_data.selected_variant);
    this.output_compare_price(form_data.selected_variant);
    this.output_total_price();
  }

  modify_url() {
    if (!this.config.has_url_params) return;
    var selected_variant = this.get_selected_variant();
    if (!selected_variant) return;
    window.history.pushState("", "", this.config.url_variant_param + selected_variant.id);
  }

  serialize(form) {
    var form = form || this.nodes.form;
    return new URLSearchParams(new FormData(form)).toString();
  }

  get_form_properties() {
    var data = Array.from(new URLSearchParams(new FormData(this.nodes.form)));
    var props = {};

    data.filter(function (entry) {
      if (entry[0].indexOf("properties") > -1) {
        props[entry[0]] = entry[1];
      }
    });

    return props;
  }

  // callback to change event on variant select
  handle_option_change() {
    var variant_select = this.nodes.variant_select;
    var frame_select = this.nodes.frame_select;
    var passepartout_select = this.nodes.passepartout_select;
    var selected_variant = variant_select.data.selected_variant.data;

    if (passepartout_select && passepartout_select.data) {
      var selected_passepartout_value = passepartout_select.data.selected_option.value;
      // generates options based on poster size
      passepartout_select.handle_option_change();
    }

    // validate passepartout if selected
    if (passepartout_select && selected_passepartout_value && selected_passepartout_value !== "null") {
      // checking if current poster size has passepartout
      if (passepartout_select.print_has_passepartout(selected_variant.title)) {
        // checking if current color option exists among options
        if (passepartout_select.get_option_by_value(selected_passepartout_value)) {
          // selecting the previously selected color
          passepartout_select.select_option_by_value(selected_passepartout_value);
        } else {
          // selecting blank option
          passepartout_select.select_blank();
        }
      } else {
        passepartout_select.select_blank();
      }
    }

    // generates options based on poster size & passepartout size
    frame_select.handle_option_change();

    this.output_prices();
    this.modify_url();
  }

  handle_frame_change(e) {
    var frame_select = this.nodes.frame_select;
    var clicked_option = e.detail;
    frame_select.assign_selected_option(clicked_option);
    this.output_prices();
  }

  handle_passepartout_change(e) {
    var passepartout_select = this.nodes.passepartout_select;
    var clicked_option = e.detail;
    passepartout_select.assign_selected_option(clicked_option);
    this.nodes.frame_select.handle_option_change();
    this.output_prices();
  }


  send_cart_request() {
    var form_data = this.get_form_data();
    if (!form_data.selected_variant) return;

    var quantity = this.get_quantity();

    var properties = this.get_form_properties();
    var bundle_id = Math.ceil(Math.random() * 100000);

    if (form_data.selected_frame || form_data.selected_passepartout) {
        properties._bundle_id = bundle_id;
    };


    // adding variant
    var items_to_add = [
      {
        quantity: quantity,
        id: form_data.selected_variant.id,
        properties: properties,
      },
    ];

    // adding frame
    if (form_data.selected_frame) {
      items_to_add.push({
        id: form_data.selected_frame.id,
        quantity: quantity,
        properties: properties,
      });
    }
    // adding passepartout
    if (form_data.selected_passepartout) {
      items_to_add.push({
        id: form_data.selected_passepartout.id,
        quantity: quantity,
        properties: properties,
      });
    }

    // sending API request
    WDN.Cart.Add({
      data: {
        items: items_to_add,
      },
      onSuccess: function (res) {
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: false,
            detail: {
              variant: form_data.selected_frame ? form_data.selected_frame.id : form_data.selected_passepartout.id,
              quantity: quantity,
              is_frame: !!form_data.selected_frame,
              ignore: true,
            },
          })
        );
      }.bind(this),
      onError: function () {},
    });
  }

  // handles click on submit button
  submit_on_click(e) {
    e ? e.preventDefault() : "";
    // this.send_cart_request();
    this.send_cart_request();
  }

  bind() {
    this.bind_element(this.nodes.variant_select, "change", this.handle_option_change.bind(this));
    this.bind_element(this.nodes.frame_select, "change", this.handle_frame_change.bind(this));
    this.bind_element(this.nodes.passepartout_select, "change", this.handle_passepartout_change.bind(this));
    this.bind_element(this.nodes.submit_button, "click", this.submit_on_click.bind(this));
  }

  handle_child_load() {
    this.config.loaded_children++;

    if (this.config.loaded_children === this.config.children_to_load) {
      this.init();
    }
  }

  get_total_price() {
    var form_data = this.get_form_data();
    var sum = 0;

    if (form_data.selected_variant) {
      sum = sum + form_data.selected_variant.price;
    }

    if (form_data.selected_frame) {
      sum = sum + form_data.selected_frame.price;
    }

    if (form_data.selected_passepartout) {
      sum = sum + form_data.selected_passepartout.price;
    }

    return sum;
  }

  get_form_data() {
    var selected_variant = this.nodes.variant_select.data.selected_variant.data;

    if (this.nodes.frame_select) {
      var selected_frame = this.nodes.frame_select.get_frame_variant();
    }

    if (this.nodes.passepartout_select) {
      var selected_passepartout = this.nodes.passepartout_select.get_selected_passepartout_variant();
    }

    return {
      selected_variant: selected_variant,
      selected_frame: selected_frame || false,
      selected_passepartout: selected_passepartout || false,
    };
  }

  wait_for_children_to_load() {
    var children_to_load = 0;

    // if variant select didnt save its data in regards to selected variant (not loaded)
    if (!this.nodes.variant_select.data) {
      children_to_load++;
      this.bind_element(this.nodes.variant_select, "variant_select:inited", this.handle_child_load.bind(this));
    }

    // if passepartout select exists, wait for it to load
    if (this.nodes.passepartout_select) {
      children_to_load++;
      this.bind_element(
        this.nodes.passepartout_select,
        "passepartout_select:inited",
        this.handle_child_load.bind(this)
      );
    }
    // if frame select exists, wait for it to load
    if (this.nodes.frame_select) {
      children_to_load++;
      this.bind_element(this.nodes.frame_select, "frame_select:inited", this.handle_child_load.bind(this));
    }

    this.config.children_to_load = children_to_load;
  }

  // module begins here
  init() {
    this.handle_option_change();
    this.output_prices();
    this.bind();
  }
}

(function () {
  var is_on_product_page = !!document.querySelector("[data-section-id='product-template']");

  var define_elements = function () {
    customElements.define("wdn-popup", WDNPopup);

    customElements.define("wdn-select", WDNSelect);

    customElements.define("wdn-variant-select", WDNVariantSelect);

    customElements.define("wdn-frame-select", WDNFrameSelect);

    customElements.define("wdn-passepartout-select", WDNPassepartoutSelect);

    customElements.define("wdn-product-form", WDNProductForm);
  };

  if (is_on_product_page) {
    window.addEventListener("load", function () {
      define_elements();
    });
  } else {
    define_elements();
  }
})();
